module.exports = __webpack_public_path__ + "img/scene.5ea2c108.jpg";